/**
 * Routeur principal des widgets Brydge
 *
 * Définit les routes pour chaque type de widget et fournit
 * le contexte commun via WidgetPage.
 *
 * @module WidgetRouter
 */

// Configuration i18next
import 'packages/common/locales/i18n';

import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import TableReservationView from './widgets/TableReservation/view/TableReservationView';
import GiftVoucherView from './widgets/GiftVoucher/view/GiftVoucherView';
import WidgetPage from './widgets/common/WidgetPage';

/**
 * Composant routeur pour les widgets
 *
 * @return {JSX.Element} Le routeur avec les routes des widgets
 */
export default function WidgetRouter() {
  return (
    <BrowserRouter>
      <WidgetPage>
        <Routes>
          <Route path="/reservations" element={<TableReservationView mode="fixed" />} />
          <Route path="/giftvouchers" element={<GiftVoucherView mode="fixed" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </WidgetPage>
    </BrowserRouter>
  );
}
